import { Component, Inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UserGroupFilters } from '@/app/platform/platform-management/user-group-block/components/user-groups-filter/user-groups-filter.component';
import { USER_GROUP_ACTIONS, UserGroupActions } from '@/app/platform/platform-data/actions/types';
import { USER_GROUP_QUERIES, UserGroupQueries } from '@/app/platform/platform-data/queries/types';
import { UserGroupEntity } from '@/app/platform/platform-data/models/user-group.entity';

@Component({
    selector: 'user-group-manager-view',
    templateUrl: './user-group-manager-view.component.html',
    styleUrls: ['./user-group-manager-view.component.css'],
    host: {
        class: 'dusk-management'
    },
    standalone: false
})
export class UserGroupManagerViewComponent implements OnInit {
  constructor(
    @Inject(USER_GROUP_ACTIONS)
    private readonly userGroupActions: UserGroupActions,
    @Inject(USER_GROUP_QUERIES)
    private readonly userGroupQueries: UserGroupQueries
  ) {}

  activeUserGroupId = '';

  filters = new UserGroupFilters();

  get userGroups$(): Observable<UserGroupEntity[]> {
    return this.userGroupQueries?.all$;
  }

  get activeUserGroup$(): Observable<UserGroupEntity> {
    return this.userGroupQueries?.one$(this.activeUserGroupId);
  }

  ngOnInit(): void {
    this.userGroupActions.loadAll();

  }

  onSelect(group: UserGroupEntity): void {
    if (group.id !== this.activeUserGroupId) {
      this.activeUserGroupId = group.id;
      if (group.isNotDefault) {
        this.userGroupActions.loadLinkedApps(group);
      }
    }
  }
}
